import { render, staticRenderFns } from "./MBChartView.vue?vue&type=template&id=06e154f8&scoped=true&class=fill-height"
import script from "./MBChartView.vue?vue&type=script&lang=ts"
export * from "./MBChartView.vue?vue&type=script&lang=ts"
import style0 from "./MBChartView.vue?vue&type=style&index=0&id=06e154f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e154f8",
  null
  
)

export default component.exports